<script setup lang="ts">
import UseSvg from "common/vue/components/UseSvg.vue";
</script>

<template>
  <div class="artwork-history-notification">
    <UseSvg class="artwork-history-notification__icon" icon="info-circle-bold" />
    <div class="artwork-history-notification__message">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.artwork-history-notification {
  display: flex;
  align-items: center;

  &__icon {
    flex: none;
    width: 24px;
    height: 24px;
    color: $app-gray-modern-400;
    margin-right: 8px;
  }

  &__message {
    flex: 1;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>
